module.exports = __webpack_public_path__ + "img/go.7caa6fae.png";